const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const InvoiceEmailSend = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'INVOICE_EMAIL_SEND_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'INVOICE_EMAIL_SEND_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default InvoiceEmailSend;